// src/routes/LeadAutomationRoutes.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PermissionRoute from './PermissionRoute';
import LeadAutomationPage from '../pages/lead-automation/LeadAutomationPage';
import LeadFormDetailPage from '../pages/lead-automation/LeadFormDetailPage';

const LeadAutomationRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <PermissionRoute requiredPermission="view_lead_forms">
            <LeadAutomationPage />
          </PermissionRoute>
        }
      />
      <Route
        path="/:id/sessions"
        element={
          <PermissionRoute requiredPermission="view_lead_forms">
            <LeadFormDetailPage />
          </PermissionRoute>
        }
      />
    </Routes>
  );
};

export default LeadAutomationRoutes;
